import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useGetLead } from './useGetLead.hook'

const useLeadById = () => {
  const { id } = useParams()

  const { lead, error, loading, getLead } = useGetLead()

  useEffect(() => {
    getLead(id)
  }, [])

  return {
    lead,
    error,
    loading,
  }
}

export { useLeadById }
